// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import THSelector from '@Molecules/THSelector/THSelector';
import { Space } from 'antd';
import React, { ReactElement, MouseEvent } from 'react';

import './FieldsetSelected.scss';

const addOnArray = (list: string[], value: string[]): string[] => [...list, ...value];

const removeOnArray = (list: string[], value: string[]): string[] => list.filter((t) => !value.includes(t)) || [];

type FieldsetSelectedProps = {
    title: string;
    selectedState: [any[], React.Dispatch<React.SetStateAction<any[]>>];
    data: any[];
    className?: string;
};

const FieldsetSelected = ({ title, selectedState, data, className }: FieldsetSelectedProps): ReactElement => {
    const i = useLocalMessage();

    const [list, setList] = selectedState;

    const selectHandler =
        (entries: typeof list) =>
        (e: MouseEvent<HTMLButtonElement>): void => {
            e.preventDefault();
            const values = entries.filter((item) => !list.includes(item));
            setList(addOnArray(list, values));
        };
    const deselectHandler =
        (entries: typeof list) =>
        (e: MouseEvent<HTMLButtonElement>): void => {
            e.preventDefault();
            const values = entries.filter((item) => list.includes(item));
            setList(removeOnArray(list, values));
        };

    return (
        <fieldset className={classList('fieldset-select__wrapper', className)}>
            <legend className="fieldset-select__legend">
                <span className="fieldset-select__legend-title">{title}</span>
                <THButton type="link" className="fieldset-select__legend-btn" onClick={selectHandler(data)}>
                    {i('common.select-all')}
                </THButton>
                /
                <THButton type="link" className="fieldset-select__legend-btn" onClick={deselectHandler(data)}>
                    {i('common.deselect-all')}
                </THButton>
            </legend>

            <THSelector<{ name: string; cortexId: string; value: string }>
                refKey="name"
                dataSource={data}
                value={list}
                onChange={(listValues) => setList(listValues)}
                watchValue
            >
                {({ name, cortexId }, selected) => (
                    <Space>
                        {selected ? <ICONS.CheckCircleTwoTone /> : <ICONS.CheckCircleOutlined />}
                        {name}
                        <span className="fieldset-select__server">[{cortexId}]</span>
                    </Space>
                )}
            </THSelector>
        </fieldset>
    );
};

export default FieldsetSelected;
